import React from 'react';
import { Text } from '../../atoms/Text';
import { List } from '../../atoms/List';
import { ListItem } from '../../atoms/ListItem';
import { Link } from '../../atoms/Link';
import './FooterSection.css';

export interface FooterLink {
  label: string;
  href: string;
  external?: boolean;
}

export interface FooterSectionProps {
  /**
   * Section title
   */
  title: string;
  /**
   * Links to display in this section
   */
  links: FooterLink[];
  /**
   * Domain to prefix for non-external links
   */
  wwwDomain?: string;
  /**
   * Custom CSS classes
   */
  className?: string;
}

export const FooterSection: React.FC<FooterSectionProps> = ({
  title,
  links,
  wwwDomain = 'www.heartinternet.uk',
  className = '',
}) => {
  const baseClass = 'hi-ui hi-ui-footer-section';
  const allClasses = `${baseClass} ${className}`.trim();
  const protocol = 'https';

  return (
    <div className={allClasses}>
      <Text variant="heading-5" className="hi-ui-footer-section__title">
        {title}
      </Text>
      <List listStyle="none" className="hi-ui-footer-section__list">
        {links.map((link) => (
          <ListItem key={link.href}>
            <Link
              href={link.external ? link.href : `${protocol}://${wwwDomain}${link.href}`}
              external={link.external}
              noUnderline
            >
              {link.label}
            </Link>
          </ListItem>
        ))}
      </List>
    </div>
  );
};
